import '../pages.css';
import useDocumentMeta from '../hooks/useDocumentMeta.js';
import { buildCtaUrl } from '../utils/attribution.js';

const APP_STORE = 'https://apps.shopify.com/account-editor';

const CHAT = [
  { q: 'Will this add work for my support team?', a: 'The opposite — customers fix their own orders before they ever open a ticket. Support volume typically drops 30–40%.' },
  { q: 'How long does setup actually take?', a: "About 5 minutes. Install, choose which edits to allow, and you're live — no code, no developer." },
  { q: 'Does it work with my fulfillment stack?', a: 'Yes — we sync with ShipBob, Sendcloud, NetSuite and more, so edits reach the warehouse before picking.' },
  { q: 'What if a customer edits an order that already shipped?', a: 'Edits stay open only during your set window — say 30 minutes. Once fulfilled, it closes automatically.' },
];

const FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: CHAT.map((c) => ({
    '@type': 'Question',
    name: c.q,
    acceptedAnswer: { '@type': 'Answer', text: c.a },
  })),
};

export default function Faqs() {
  useDocumentMeta({
    title: 'Shopify Order Editing FAQs | Account Editor',
    description:
      'Get answers about Account Editor setup, order editing windows, fulfilment sync, cancellations, and how self-service edits affect customer support.',
    path: '/faqs',
    jsonLd: FAQ_JSONLD,
  });

  return (
    <div className="aehome">
      <section className="qna" id="qnaSec">
        <div className="qna__inner">
          <div className="qna__intro">
            <span className="section-label">Questions, answered</span>
            <h1 className="qna__title">Still on the fence?</h1>
            <p className="qna__sub">Ask us anything — here are the answers merchants reach for most before installing.</p>
            <div className="qna__fixer">
              <div className="qna__fixer-img"><img src="/images/fixer-profile.webp" alt="The Fixer" /></div>
              <div className="qna__fixer-bubble">
                <strong>Hi! I&rsquo;m the Fixer.</strong>
                <span>I&rsquo;m here to help with any questions about orders, billing, or your account.</span>
              </div>
            </div>
            <div className="qna__cta">
              <div className="qna__cta-text">
                <strong>Still have a question?</strong>
                <span>Talk to a real human — we'll map it to your store in 15 minutes.</span>
              </div>
              <a href={APP_STORE} className="btn btn--primary-lg">Install free on Shopify <i className="ph ph-arrow-right" aria-hidden="true" /></a>
            </div>
          </div>
          <div className="qna__chat">
            {CHAT.map((c) => (
              <div key={c.q}>
                <div className="qna__row qna__row--q">
                  <div className="qna__bubble qna__bubble--q">{c.q}</div>
                </div>
                <div className="qna__row qna__row--a">
                  <img className="qna__avatar" src="/images/fixer-profile.webp" alt="" />
                  <div className="qna__bubble qna__bubble--a">{c.a}</div>
                </div>
              </div>
            ))}
            <div className="qna__typing"><i /><i /><i /></div>
          </div>
        </div>
      </section>
    </div>
  );
}
